import { compose } from 'recompose'
import MobileFixedWrapper from './MobileFixedWrapper'

export default compose()(MobileFixedWrapper)

